import React from "react";
import { Box, Card, LinearProgress, Typography } from "@mui/material";

interface OcCardProps {
  label: string | React.ReactNode;
  children: React.ReactNode;
  loading?: boolean;
  error?: boolean;
  height?: string | number | null;
}

export const OcCard = ({
  label,
  children,
  loading,
  error,
  height = null,
}: OcCardProps) => {
  const cardStyle: React.CSSProperties = {
    borderRadius: "4px",
    borderColor: error ? "#cc0033" : "white",
    overflow: "visible",
  };
  if (height) {
    cardStyle.height = height;
  }

  return (
    <Card variant="outlined" style={cardStyle}>
      <Box
        style={{
          fontSize: "20px",
          letterSpacing: "0.15px",
          padding: "0px 16px",
          color: "#5E6366",
        }}
      >
        <Box
          style={{
            fontSize: "20px",
            letterSpacing: "0.15px",
            padding: "10px 16px",
            color: "#5E6366",
            borderBottom: loading ? "" : "2px solid #C6CACC",
          }}
        >
          <Typography className="oc-card-h6-title" variant="h6" color="#5E6366">
            {label}
          </Typography>
        </Box>
        {loading ? <LinearProgress color="primary" /> : <Box height="2px" />}
      </Box>
      <Box padding="16px 16px 16px 16px">
        <>{children}</>
      </Box>
    </Card>
  );
};

export default OcCard;
